var exports = {
  "oY": "x31de4314--10b209--input-row",
  "eo": "x31de4314--10b209--input-label",
  "Ar": "x31de4314--10b209--input-max_bet",
  "Uo": "x31de4314--10b209--buttons",
  "Je": "x31de4314--10b209--buttons-right",
};

module.exports = exports;
